import { ColumnTable, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { Announcement } from '../types';
import dayjs from 'dayjs';

type useAdminColumnsProps = {
  onPressEdit: (row: Announcement) => void;
  onPressDelete: (row: Announcement) => void;
};

export const useAdminColumns = ({
  onPressDelete,
  onPressEdit,
}: useAdminColumnsProps) => {
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_ANNOUNCEMENTS_ADMIN_LIST,
  );

  const columns = useMemo<ColumnTable<Announcement>[]>(
    () => [
      {
        headerText: t(`table.title`),
        tdClassName: 'text-center fw-700',
        thClassName: 'text-center',
        columnName: 'title',
        width: 190,
      },
      {
        headerText: t(`table.school`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'school',
        width: 190,
        cellFormat({ value }) {
          return value ? value?.name : '';
        },
      },
      {
        headerText: t(`table.academicLevel`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'academicLevel',
        width: 190,
        cellFormat({ value }) {
          return value ? value?.name : '';
        },
      },
      {
        headerText: t(`table.studyPlan`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'studyPlan',
        width: 190,
        cellFormat({ value }) {
          return value ? value?.name : '';
        },
      },
      {
        headerText: t(`table.publishAt`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'publishAt',
        width: 190,
        cellFormat({ value }) {
          return value ? dayjs(value).format('DD/MM/YYYY') : 'N/D';
        },
      },
      {
        headerText: t(`table.validUntilAt`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'validUntilAt',
        width: 190,
        cellFormat({ value }) {
          return value ? dayjs(value).format('DD/MM/YYYY') : 'N/D';
        },
      },
      {
        headerText: t(`table.actions`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        columnName: 'id',
        width: 190,
        cellFormat({ row }) {
          return (
            <div>
              <button
                className="btn"
                type="button"
                onClick={() => onPressEdit(row)}
              >
                <Icon name="edit" />
              </button>
              <button
                className="btn"
                type="button"
                onClick={() => onPressDelete(row)}
              >
                <Icon name="trash" />
              </button>
            </div>
          );
        },
      },
    ],
    [t, onPressEdit, onPressDelete],
  );
  return columns;
};
